module.exports = __webpack_public_path__ + "img/mobile.b25c1731.png";